import { LiveStreamApi } from '../../generated/api';
import configuration from './configuration';

const livestreamsService = new LiveStreamApi(configuration);

export default livestreamsService;
